// v222 — Build-Info landing page (item 33 Phase A of
// docs/PRODUCT-ROADMAP.md).
//
// The sidebar nav link "Build-Info" lands here; we list every project
// the caller can read with a "Browse builds" jump to the per-project
// browse page. A future Phase B can fold an org-wide recent-builds
// feed in alongside; for Phase A the project picker is enough.

import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { Activity, ChevronRight } from 'lucide-react';
import { useProjects } from '../api/client';
import { Card, CardBody, CardHeader } from '../components/ui/Card';

export function Builds() {
  const { t } = useTranslation();
  const { data: projects, error, isLoading } = useProjects();

  return (
    <div className="space-y-6">
      <div>
        <p className="orb-eyebrow text-accent/80 mb-2">{t('builds.eyebrow')}</p>
        <h1 className="text-2xl font-display font-semibold text-fg leading-tight">
          {t('builds.title')}
        </h1>
        <p className="text-fg-muted text-sm mt-2 max-w-3xl">
          <Trans
            i18nKey="builds.intro"
            components={[<code key={0} className="font-mono" />]}
          />
        </p>
      </div>

      <Card>
        <CardHeader
          title={t('builds.projectsCard.title')}
          description={t('builds.projectsCard.description')}
        />
        {isLoading && (
          <CardBody>
            <p className="text-fg-muted text-sm">{t('builds.loading')}</p>
          </CardBody>
        )}
        {error && (
          <CardBody>
            <p className="text-danger font-mono text-sm">{String(error)}</p>
          </CardBody>
        )}
        {projects?.length === 0 && (
          <CardBody>
            <p className="text-fg-muted text-sm">
              <Trans
                i18nKey="builds.empty"
                components={[<Link key={0} to="/projects" className="text-accent" />]}
              />
            </p>
          </CardBody>
        )}
        {projects && projects.length > 0 && (
          <div className="divide-y divide-border">
            {projects.map((p) => (
              <Link
                key={p.id}
                to={`/projects/${p.id}/builds`}
                className="flex items-center justify-between px-5 py-3 hover:bg-bg-hover transition-colors"
              >
                <div className="flex items-center gap-3 min-w-0">
                  <Activity className="h-4 w-4 text-fg-subtle shrink-0" />
                  <div className="min-w-0">
                    <div className="font-medium text-fg truncate">{p.name}</div>
                    <code className="text-xs text-fg-muted">{p.slug}</code>
                  </div>
                </div>
                <ChevronRight className="h-4 w-4 text-fg-subtle" />
              </Link>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
